import React from 'react';

import MuiButton from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import './table.scss';

export const StyledIconButton = withStyles((theme) => ({
  root: {
    minWidth: '36px',
    width: '36px',
    height: '30px',
    borderRadius: '8px',
    border: '1px solid var(--app-border)',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 'bold',
    background: 'var(--app-surface)',
    color: 'var(--app-text)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}))(MuiButton);

const TableButton = (props) => {
  const {
    onClick = () => {},
    color,
    children,
    id,
  } = props;

  return (
    <StyledIconButton
      className='table-button'
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      id={id}
      style={{ backgroundColor: color || 'var(--app-surface)' }}
    >
      {children}
    </StyledIconButton>
  )
};

export default TableButton;
